import { withExperienceNotifier } from '@helpcenter/analytics-components';
import RequestCreateForm from './request-create-form';

export default withExperienceNotifier('request-create-form')(RequestCreateForm);
